function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { StyleSheet, SafeAreaView, Platform, StatusBar } from 'react-native';
import { NativeBaseProvider, View, Center, VStack, Spinner, Text, extendTheme, v33xTheme } from 'native-base';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import NotificationScreen from '../notification/NotificationScreen';
import Login from '../forms/Login';
import ForumHomeScreen from '../content/ForumHomeScreen';
import PrivateMessageScreen from '../privateMessages/PrivateMessageScreen';
import BadgeScreen from '../notification/BadgeScreen';
import SingleTopicScreen from '../content/topics/SingleTopicScreen';
import SearchForumScreen from '../search/SearchForumScreen';
import { colors, fontSizes, breakpoints } from '../../theme';
import { DEVICE_HEIGHT } from '../../components/Constants';
const theme = extendTheme({
  v33xTheme,
  colors,
  fontSizes,
  breakpoints
});
const Stack = createNativeStackNavigator();
const titleSuffix = '@ Food Revolution Network';
const screenOptions = {
  headerShown: false,
  title: 'Food Revolution Network'
};
const ForumPresentation = props => {
  const {
    forumKey,
    showLoginScreen,
    showSpinner,
    userAuthenticated,
    isGuidelineModalOpen,
    setIsGuidelineModalOpen,
    toggleProfileModal,
    dispatchForumAuth,
    trackForum
  } = props;
  return /*#__PURE__*/React.createElement(NativeBaseProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(NavigationContainer, null, /*#__PURE__*/React.createElement(SafeAreaView, {
    style: styles.safeArea
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.mainContainer,
    justifyContent: showSpinner ? 'center' : 'none'
  }, /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(View, {
    w: '100%',
    maxW: 1200
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 1,
    justifyContent: 'center',
    p: {
      base: 0,
      lg: 5
    },
    w: '100%'
  }, showSpinner && !showLoginScreen ? /*#__PURE__*/React.createElement(View, {
    h: Platform.OS === 'web' ? Math.floor(DEVICE_HEIGHT * 0.66) : '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Spinner, {
    mb: 3
  }), /*#__PURE__*/React.createElement(Text, null, "Loading Forum ...")) : userAuthenticated ? /*#__PURE__*/React.createElement(Stack.Navigator, {
    initialRouteName: 'Topics',
    screenOptions: screenOptions
  }, /*#__PURE__*/React.createElement(Stack.Screen, {
    name: 'Topics',
    options: {
      title: `Topics ${titleSuffix}`
    }
  }, props => /*#__PURE__*/React.createElement(ForumHomeScreen, _extends({}, props, {
    forumKey: forumKey,
    isGuidelineModalOpen: isGuidelineModalOpen,
    setIsGuidelineModalOpen: setIsGuidelineModalOpen,
    toggleProfileModal: toggleProfileModal,
    dispatchForumAuth: dispatchForumAuth,
    trackForum: trackForum
  }))), /*#__PURE__*/React.createElement(Stack.Screen, {
    name: 'Notifications',
    options: {
      title: `Notifications ${titleSuffix}`
    }
  }, props => /*#__PURE__*/React.createElement(NotificationScreen, _extends({}, props, {
    toggleProfileModal: toggleProfileModal,
    dispatchForumAuth: dispatchForumAuth
  }))), /*#__PURE__*/React.createElement(Stack.Screen, {
    name: 'PrivateMessage',
    options: {
      title: `Private Message ${titleSuffix}`
    }
  }, props => /*#__PURE__*/React.createElement(PrivateMessageScreen, _extends({}, props, {
    toggleProfileModal: toggleProfileModal,
    dispatchForumAuth: dispatchForumAuth,
    trackForum: trackForum
  }))), /*#__PURE__*/React.createElement(Stack.Screen, {
    name: 'Badge',
    component: BadgeScreen,
    options: {
      title: `Badge ${titleSuffix}`
    }
  }), /*#__PURE__*/React.createElement(Stack.Screen, {
    name: 'SingleTopic',
    component: SingleTopicScreen,
    options: {
      title: `Single Topic ${titleSuffix}`
    }
  }), /*#__PURE__*/React.createElement(Stack.Screen, {
    name: 'SearchForum',
    component: SearchForumScreen,
    options: {
      title: `Search Forum ${titleSuffix}`
    }
  })) : /*#__PURE__*/React.createElement(Stack.Navigator, {
    initialRouteName: 'Login',
    screenOptions: screenOptions
  }, /*#__PURE__*/React.createElement(Stack.Screen, {
    name: 'Login',
    component: Login,
    options: {
      title: `Login ${titleSuffix}`
    }
  })))))))));
};
export default ForumPresentation;
const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: colors.forum.maincontainer.bg
  },
  safeArea: {
    backgroundColor: colors.forum.safearea.bg,
    flex: 1,
    paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
  }
});
//# sourceMappingURL=ForumPresentation.js.map